var id = 0;
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + Math.random()).toString(36));
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/$.uid.js
 ** module id = 19
 ** module chunks = 0
 **/